import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { MhsAiToolsApiClient, Procedure, Suggestion } from '../api/mhsAiToolsApiClient';

@Injectable({
  providedIn: 'root',
})
export class AitoolsService {
  readonly aiApiClient = inject(MhsAiToolsApiClient);
  async getMedServiceGroupSuggestions(medServiceNames: string[]): Promise<Suggestion[]> {
    const request = medServiceNames.map((name) => {
      return {
        name: name,
        id: '0',
      } as Procedure;
    });
    const response = await firstValueFrom(
      this.aiApiClient.receive_procedures_api_ai_tools_context_procedure_set_generate_names_post(
        request,
      ),
    );
    if (!response.isValid) {
      throw new Error(response.message);
    }
    return response.suggestions;
  }
}
